import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import UserOrderDetail from './components/UserOrderDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageUserOrder',
  components: {
    UserOrderDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;